<template>
  <!--ctn_etc -->
  <div class="ctn_etc">

    <!--login -->
    <div class="login">
      <div class="login-logo"></div>
      <div class="titline"></div>
      <div class="input_txtbox">
        <div class="topTitle">이메일주소 입력</div>
        <span class="input_txt" :class="{ 'warning-border': warningBorder }" style="margin-right: 0;">
          <input type="email" v-model="model.email" maxlength="512" @keyup.enter="loginWebex">
        </span>
      </div>
      <div class="waring-txt-wrap" :class="{isWarningActive: isWarningActive}">
        <img class="warning-txt-icon" src="static/webex-cloud/images/warning.png">
        <div class="warning-txt">계정을 찾을 수 없습니다.</div>
      </div>
    </div>
    <!--//login -->

    <div class="btn_crud" style="margin-top:10px">
      <a @click="loginWebex" class="login-btn small" :class="{activeBtn: activeBtn}" style="width: 320px; margin:0;">다음 ></a>
    </div>

  </div>
  <!--//ctn_etc -->
</template>

<script>
import API from '@/api';
import pkg from '../../package';
import { mapState } from 'vuex';
import menu from '@/api/menu';
import Util from '@/util';
export default {
  data: () => ({
    title: pkg.title,
    isSSO: pkg.isSSO,
    mode: {
      login: true
    },
    error: null,
    loading: false,
    model: {
      username: '',
      email: '',
      password: '',
      passwordAgain: ''
    },
    defaultModel: {
      username: '',
      email: '',
      password: '',
      passwordAgain: ''
    },
    settings: {
      organizations: {
        type: 'local'
      },
      meetings: null,
      webex: {
        useBot: false,
        botKey: ''
      }
    },
    activeBtn: false,
    warningBorder: false,
    isWarningActive: true,
    defaultSettings: API.defaultSettings,
    titleImg: '/static/images/login_title.gif'
  }),
  computed: {
    // 다시 접속 시 Login 하도록
    // ...mapState([
    //   'isUserLoggedIn'
    // ])
  },
  watch: {
    'mode.login': {
      handler (val) {
        if (!val) {
          this.model = Object.assign({}, this.defaultModel);
          this.titleImg = '/static/images/signup_title.gif';
        } else {
          this.titleImg = '/static/images/login_title.gif';
        }
      }
    },
    'model.email': {
      handler (val) {
        if (this.warningBorder === true) {
          this.warningBorder = false;
          this.isWarningActive = true;
        }
        
        if (val === '' || val === null) {
          this.activeBtn = false;
        } else {
          this.activeBtn = true;
        }
      }
    }
  },
  async created () {
    this.menuSorting();
    if (!Util.hasSession(this, true)) return;

    // await this.getSettings();
    
    console.log(`menu`);
    console.log(menu);
    let menuPath = menu[1].path === undefined ? '/' + menu[1].items[0].component : menu[1].path;
    this.$router.replace(menuPath);
  },
  async mounted () {
    if (pkg.isHanwha) {
      this.$router.replace({ name: 'AccessDenied' });
      return;
    }
    // await this.getSettings();
  },
  methods: {
    join () {
      this.$router.push({ name: 'Join' });
    },
    async getSettings () {
      await this.$http.get('/api/v1/systems').then(response => {
        this.settings = response.data;
        if (this.settings === '' || this.settings === null) {
          this.settings = Object.assign({}, this.defaultSettings);
        }
        this.$store.dispatch('setSettings', this.settings);
      }).catch(error => {
        this.$store.dispatch('setSettings', this.defaultSettings);
      });
    },
    menuSorting () {
      menu.forEach((element) => {
        if (element.items) {
          let items = element.items;
          items.sort((a, b) => {
            return a.sort < b.sort ? -1 : a.sort > b.sort ? 1 : 0;
          });
        }
      });
    },
    login () {
      this.loading = true;
      if (this.mode.login) {
        console.log(this.model);
        this.$http.post('/api/auth/login', this.model).then((response) => {
          if (response.data.user.status === 'r') {
            window.getApp.$emit('APP_USER_LOGIN_REQUESTED');
            this.loading = false;
            return;
          }
          this.loginSuccess(response);
        }).catch(error => {
          this.loading = false;
          this.error = error.response.data.error;
        });
      } else {
        this.$http.post('/api/auth/register', this.model).then((response) => {
          window.getApp.$emit('APP_USER_REGISTER');
          this.loading = false;
          // this.loginSuccess(response);
          this.model = Object.assign({}, this.defaultModel);
          this.mode.login = true;
          this.error = undefined;
        }).catch(error => {
          this.loading = false;
          this.error = error.response.data.error;
        });
      }
    },
    async loginSuccess (response) {
      this.$store.dispatch('setToken', response.data.token);
      this.$store.dispatch('setUser', response.data.user);
      await this.getSettings();
      
      setTimeout(() => {
        let menuPath = menu[1].path === undefined ? '/' + menu[1].items[0].component : menu[1].path;
        console.log(`menuPath`);
        console.log(menuPath);
        this.$router.replace(menuPath);
        this.loading = false;
      }, 500);
    },
    async loginWebex () {
      if (this.model.email === '' || this.model.email === null) {
        Util.snackBarOpen(this.$t('이메일주소를 먼저 입력해주세요'), 'warning');
      } else {
        this.$store.dispatch('setWebexLoginMode', true);
        /* this.$router.push('/auth/login?email=ihlee@ecstel.co.kr'); */
        let params = {
          email: this.model.email
        };

        this.$http.get(`/api/auth/login`, { params: params }).then((response) => {
        // this.$http.get(`/api/auth/login?email=${this.model.email}`).then((response) => {
          let data = response.data;
          
          if (data.loginType === 'cisco') {
            /* this.$router.replace(data.url); */
            window.location.assign(data.url);
          } else if (data === 'noUser') {
            this.warningBorder = true;
            this.isWarningActive = false;
          } else {
            this.$router.push(`/loginPW?email=${encodeURIComponent(this.model.email)}`);
          }
        }).catch(error => {        
        });
      } 
    }
  },
};
</script>
<style scoped lang="css">
.ctn_etc .login {
  width: 380px;
  margin: 0 auto;
}
.contents {
  width: 100%;
  text-align: center;
}
.login-wrapper {
  margin: auto;
  margin-top: 300px;
  width: 500px;
}
.cui-input{
  -webkit-font-smoothing: antialiased;
  color: #000;
  border-color: rgba(0,0,0,.16);
  box-sizing: border-box;
  padding-top: .5625rem;
  padding-bottom: .4375rem;
  border: 1px solid rgba(0,0,0,.16);
  transition: box-shadow ease-out .15s;
  -webkit-appearance: none;
  font: inherit;
  margin: 0;
  overflow: visible;
/*   font-family: "CiscoSansTT Light","Helvetica Neue",Helvetica,Arial,sans-serif; */
  font-size: .875rem;
  line-height: 1.00001;
  background-color: rgba(0,0,0,.08);
  height: 2.5rem;
  max-width: 20rem;
  border-radius: 6.25rem;
  min-height: 2.5rem;
  padding-right: 1.25rem;
  padding-left: 1.25rem;
  margin-bottom: .5rem;
  width: 20rem;
}
.cui-input:focus {
/*outline:3px solid #d50000; */
  outline:none;
}
.btnOK{
  box-sizing: inherit;
  -webkit-font-smoothing: antialiased;
  font: inherit;
  margin: 0;
  overflow: visible;
  text-transform: none;
  position: relative;
  display: inline-block;
/*   font-family: "CiscoSansTT Regular","Helvetica Neue",Helvetica,Arial,sans-serif; */
  font-weight: 400;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  border: none;
  min-width: 4.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  border-radius: 1.125rem;
  padding: .375rem;
  transition: background-color 150ms ease;
  -webkit-appearance: button;
  border-color: transparent;
  height: 2.5rem;
  min-height: 2.5rem;
/*   padding-right: 1.25rem;
  padding-left: 1.25rem; */
  margin-bottom: .5rem;
  width: 20rem;
  color: #fff;
  background-color: #06b1d2;
}
.ctn_etc .udline {
  display: inline-block;
  font-size: 14px;
  margin-top: 15px;
  color: #fa4242;
}
.ctn_etc .udline .line {
  display: block;
  margin: 0;
}

.waring-txt-wrap {
  margin-top: 10px;
  position: relative;
}
.warning-txt {
  font-size: 9pt;
  font-weight: 300;
  color: red;
  margin-left: 5px;
  text-align: center;
}
.warning-txt-icon {
  width: 14px;
  height: 14px;
  float: left;
  padding-top: 3px;
  position: absolute;
  left: 29%;
  top: -1px;
}

.warning-border {
  border: 1.5px solid red !important;
}

.isWarningActive{
  display: none;
}

.login-btn{
  background: #fa4242;
  color: white;
}

.activeBtn{
  color: white !important;
  background: #fa4242 !important;
}

.topTitle {
  background: #fff;
  width: 50px;
  bottom: 17px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #80868b;
  font-size: 12px;
  font-weight: 400;
  left: 40px;
  max-width: calc(100% - (2*8px));
  overflow: hidden;
  padding: 0 8px;
  text-overflow: ellipsis;
  -webkit-transition: transform 150ms cubic-bezier(0.4,0,0.2,1),opacity 150ms cubic-bezier(0.4,0,0.2,1);
  -webkit-transition: opacity 150ms cubic-bezier(0.4,0,0.2,1),-webkit-transform 150ms cubic-bezier(0.4,0,0.2,1);
  transition: opacity 150ms cubic-bezier(0.4,0,0.2,1),-webkit-transform 150ms cubic-bezier(0.4,0,0.2,1);
  transition: transform 150ms cubic-bezier(0.4,0,0.2,1),opacity 150ms cubic-bezier(0.4,0,0.2,1);
  transition: transform 150ms cubic-bezier(0.4,0,0.2,1),opacity 150ms cubic-bezier(0.4,0,0.2,1),-webkit-transform 150ms cubic-bezier(0.4,0,0.2,1);
  white-space: nowrap;
  width: 100px;
  z-index: 1;
  position: relative;
  top: 10px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue